import Magnolia1 from '../Magnolia/Magnolia (1).webp'
import Magnolia2 from '../Magnolia/Magnolia (2).webp'
import Magnolia3 from '../Magnolia/Magnolia (3).webp'
import Magnolia4 from '../Magnolia/Magnolia (4).webp'
import Magnolia5 from '../Magnolia/Magnolia (5).webp'
import Magnolia6 from '../Magnolia/Magnolia (6).webp'
import Magnolia7 from '../Magnolia/Magnolia (7).webp'

const Magnoliaimages =[
Magnolia1,Magnolia2,Magnolia3,Magnolia4,Magnolia5,Magnolia6,Magnolia7
]

export default Magnoliaimages;